import styled from "styled-components"
import { Link } from "gatsby"

const Container = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 0 20px;
`

const Button = styled(Link)`
  align-items: center;
  background-color: ${props => props.theme.colors.primary};
  border-radius: 20px;
  color: #fff;
  display: flex;
  font-size: 13px;
  font-weight: ${props => props.theme.title.w};
  height: 35px;
  padding: 0 20px;
  transition: opacity 0.3s;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 14px;
    height: 40px;
    padding: 0 30px;
  }

  &:before {
    display: block;
    font-size: 10px;
    padding-left: 15px;
    order: 2;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 11px;
      padding-left: 25px;
    }
  }

  .no-touchevents &:hover {
    opacity: 0.7;
  }
`

export const sLayout = {
  Container,
  Button,
}
